// Bilingual content for Multident landing page (ES default / EN)

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      technology: "Tecnología",
      cases: "Casos reales",
      testimonials: "Testimonios",
      contact: "Contacto",
      book: "Agendar cita",
    },
    hero: {
      overline: "Clínica dental premium",
      title_a: "Tu sonrisa",
      title_b: "puede cambiar",
      title_c: "tu vida.",
      sub: "En Multident transformamos sonrisas, autoestima y confianza con la tecnología dental más avanzada.",
      cta_book: "Agendar cita",
      cta_wa: "WhatsApp",
      cta_cases: "Ver casos reales",
      stat_a: "Devolviendo sonrisas desde 2009",
      stat_b: "Amplia experiencia",
    },
    emotional: {
      overline: "Lo que sientes hoy",
      title: "Tu sonrisa no debería darte inseguridad…",
      title_accent: "debería darte poder.",
      sub: "Sabemos que detrás de cada boca cerrada hay una historia. En Multident la escuchamos — y la transformamos.",
      items: [
        { k: "Dientes amarillos", v: "Recupera el blanco natural sin sensibilidad." },
        { k: "Dientes chuecos", v: "Ortodoncia invisible diseñada digitalmente." },
        { k: "Espacios entre dientes", v: "Carillas estéticas en armonía con tu rostro." },
        { k: "Miedo a sonreír", v: "Diseño de sonrisa pensado para ti." },
        { k: "Mal aliento", v: "Diagnóstico clínico y plan personalizado." },
        { k: "Inseguridad al hablar", v: "Rehabilitación oral integral premium." },
      ],
    },
    services: {
      overline: "Lo que hacemos",
      title: "Servicios diseñados",
      title_accent: "para resultados extraordinarios.",
      list: [
        { t: "Diseño de sonrisa", d: "Planificación digital 3D para una sonrisa hecha a tu medida." },
        { t: "Carillas dentales", d: "Carillas ultradelgadas con acabado natural y luminoso." },
        { t: "Ortodoncia", d: "Brackets estéticos y autoligado con resultados visibles." },
        { t: "Implantes dentales", d: "Implantes de titanio guiados por cirugía digital." },
        { t: "Blanqueamiento", d: "Blanco natural sin sensibilidad, en una sesión." },
        { t: "Rehabilitación oral", d: "Recupera función y estética con un plan integral." },
        { t: "Invisalign", d: "Alineadores invisibles que no interrumpen tu vida." },
        { t: "Limpieza dental", d: "Higiene profesional premium con tecnología ultrasónica." },
      ],
      learn: "Conocer más",
    },
    tech: {
      overline: "Tecnología",
      title: "Tecnología avanzada para",
      title_accent: "resultados extraordinarios.",
      sub: "Cada paso de tu tratamiento está guiado por equipos de última generación.",
      items: [
        { t: "Escáner intraoral 3D", d: "Sin moldes incómodos. Precisión sub-milimétrica." },
        { t: "Radiografía digital", d: "Diagnóstico inmediato con la mínima radiación." },
        { t: "Impresión 3D dental", d: "Carillas, alineadores y guías hechas en casa." },
        { t: "Planificación digital", d: "Visualiza tu nueva sonrisa antes de empezar." },
      ],
    },
    gallery: {
      overline: "Casos reales",
      title: "Antes y después",
      sub: "Resultados reales de pacientes Multident. Desliza para ver la transformación.",
      before: "Antes",
      after: "Después",
    },
    testimonials: {
      overline: "Testimonios",
      title: "Lo que dicen quienes",
      title_accent: "ya sonríen distinto.",
      list: [
        { name: "Enrique", role: "Cirugía de tercer molar", text: "No sentí nada del procedimiento. Sin duda me voy a retirar las otras muelas del juicio aquí, excelente el Dr. Aldo Jiménez." },
        { name: "Ana Dalia", role: "Ortodoncia", text: "He visto cambios en mis dientes. Me siento bien con cómo está quedando mi sonrisa." },
        { name: "Paola", role: "Diseño de sonrisa", text: "Volví a sentirme segura." },
      ],
    },
    trust: {
      overline: "Por qué Multident",
      title: "Más que dientes,",
      title_accent: "transformamos vidas.",
      sub: "Tu sonrisa merece algo extraordinario. Y nosotros estamos aquí para construirlo, paso a paso, contigo.",
      pillars: [
        { t: "Atención personalizada", d: "Un plan único para cada paciente. Sin recetas genéricas." },
        { t: "Ambiente cómodo", d: "Espacios pensados para que te sientas tranquilo desde el primer día." },
        { t: "Experiencia premium", d: "Materiales y procesos al nivel de las mejores clínicas del mundo." },
      ],
    },
    form: {
      overline: "Agenda tu valoración",
      title: "Tu nueva sonrisa",
      title_accent: "comienza hoy.",
      sub: "Reserva una cita de valoración. Te contactamos en menos de 24 horas.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      service: "Servicio de interés",
      date: "Fecha preferida",
      message: "Cuéntanos brevemente lo que buscas (opcional)",
      submit: "Agendar valoración",
      sending: "Enviando…",
      success: "¡Listo! Te contactaremos muy pronto.",
      error: "No pudimos enviar tu solicitud. Intenta de nuevo.",
      select_service: "Selecciona un servicio",
    },
    cta_final: {
      title: "Tu nueva sonrisa",
      title_accent: "comienza hoy.",
      sub: "Una valoración. Una conversación. Una vida con más confianza.",
      btn: "Agendar valoración",
    },
    footer: {
      tagline: "Multident — Sonrisas que transforman vidas.",
      contact: "Contacto",
      hours: "Horario",
      hours_v: "Lun – Vie · 9:00 – 14:00 y 16:00 – 20:00 · Sáb · 10:00 – 14:00",
      address: "Av. Premium 1234, Centro Histórico",
      follow: "Síguenos",
      rights: "Todos los derechos reservados.",
    },
    misc: {
      whatsapp: "Escríbenos por WhatsApp",
    },
  },
  en: {
    nav: {
      services: "Services",
      technology: "Technology",
      cases: "Real cases",
      testimonials: "Testimonials",
      contact: "Contact",
      book: "Book a visit",
    },
    hero: {
      overline: "Premium dental clinic",
      title_a: "Your smile",
      title_b: "can change",
      title_c: "your life.",
      sub: "At Multident we transform smiles, self-esteem and confidence with the most advanced dental technology.",
      cta_book: "Book a visit",
      cta_wa: "WhatsApp",
      cta_cases: "See real cases",
      stat_a: "Bringing smiles back since 2009",
      stat_b: "Extensive experience",
    },
    emotional: {
      overline: "What you feel today",
      title: "Your smile shouldn't make you insecure…",
      title_accent: "it should make you powerful.",
      sub: "We know there's a story behind every closed mouth. At Multident we listen to it — and transform it.",
      items: [
        { k: "Yellow teeth", v: "Recover natural white without sensitivity." },
        { k: "Crooked teeth", v: "Digitally-designed invisible orthodontics." },
        { k: "Gaps between teeth", v: "Aesthetic veneers in harmony with your face." },
        { k: "Fear of smiling", v: "A smile design made just for you." },
        { k: "Bad breath", v: "Clinical diagnosis and personalized plan." },
        { k: "Speaking insecurity", v: "Premium integral oral rehabilitation." },
      ],
    },
    services: {
      overline: "What we do",
      title: "Services designed",
      title_accent: "for extraordinary results.",
      list: [
        { t: "Smile Design", d: "3D digital planning for a smile tailored to you." },
        { t: "Dental Veneers", d: "Ultra-thin veneers with a natural, luminous finish." },
        { t: "Orthodontics", d: "Aesthetic brackets with visible results." },
        { t: "Dental Implants", d: "Titanium implants guided by digital surgery." },
        { t: "Whitening", d: "Natural white without sensitivity, in one session." },
        { t: "Oral Rehabilitation", d: "Function and aesthetics back, in one plan." },
        { t: "Invisalign", d: "Invisible aligners that won't interrupt your life." },
        { t: "Dental Cleaning", d: "Premium professional hygiene with ultrasonic tech." },
      ],
      learn: "Learn more",
    },
    tech: {
      overline: "Technology",
      title: "Advanced technology for",
      title_accent: "extraordinary results.",
      sub: "Every step of your treatment is guided by next-generation equipment.",
      items: [
        { t: "3D intraoral scanner", d: "No uncomfortable molds. Sub-millimeter precision." },
        { t: "Digital X-Ray", d: "Instant diagnosis with minimal radiation." },
        { t: "3D dental printing", d: "Veneers, aligners and guides made in-house." },
        { t: "Digital planning", d: "Preview your new smile before starting." },
      ],
    },
    gallery: {
      overline: "Real cases",
      title: "Before & After",
      sub: "Real results from Multident patients. Drag the slider to reveal the transformation.",
      before: "Before",
      after: "After",
    },
    testimonials: {
      overline: "Testimonials",
      title: "What those who now",
      title_accent: "smile differently say.",
      list: [
        { name: "Enrique", role: "Third molar surgery", text: "I didn't feel a thing during the procedure. I'll definitely come back for the rest of my wisdom teeth. Dr. Aldo Jiménez is excellent." },
        { name: "Ana Dalia", role: "Orthodontics", text: "I'm seeing real changes in my teeth. I feel great about how my smile is coming along." },
        { name: "Paola", role: "Smile design", text: "I feel confident again." },
      ],
    },
    trust: {
      overline: "Why Multident",
      title: "More than teeth,",
      title_accent: "we transform lives.",
      sub: "Your smile deserves something extraordinary. We're here to build it, step by step, with you.",
      pillars: [
        { t: "Personalized care", d: "A unique plan for each patient. No generic recipes." },
        { t: "Comfortable space", d: "Spaces designed for you to feel calm from day one." },
        { t: "Premium experience", d: "Materials and processes on par with the world's best clinics." },
      ],
    },
    form: {
      overline: "Book your assessment",
      title: "Your new smile",
      title_accent: "starts today.",
      sub: "Book a free assessment. We'll contact you in under 24 hours.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      service: "Service of interest",
      date: "Preferred date",
      message: "Tell us briefly what you're looking for (optional)",
      submit: "Book assessment",
      sending: "Sending…",
      success: "Done! We'll reach out very soon.",
      error: "We couldn't send your request. Please try again.",
      select_service: "Select a service",
    },
    cta_final: {
      title: "Your new smile",
      title_accent: "starts today.",
      sub: "One assessment. One conversation. A life with more confidence.",
      btn: "Book assessment",
    },
    footer: {
      tagline: "Multident — Smiles that transform lives.",
      contact: "Contact",
      hours: "Hours",
      hours_v: "Mon – Fri · 9:00 – 14:00 & 16:00 – 20:00 · Sat · 10:00 – 14:00",
      address: "1234 Premium Ave, Old Town",
      follow: "Follow us",
      rights: "All rights reserved.",
    },
    misc: {
      whatsapp: "Chat with us on WhatsApp",
    },
  },
};

export const SITE = {
  whatsapp_number: "522292697376", // international format, no '+'
  whatsapp_text_es: "Hola Multident, me gustaría agendar una valoración.",
  whatsapp_text_en: "Hi Multident, I'd like to book an assessment.",
  phone_display: "+52 229 589 4884",
  whatsapp_display: "+52 229 269 7376",
  email: "Multidentver239@hotmail.com",
  instagram: "https://instagram.com/multident_veracruz",
  facebook: "https://facebook.com/Multident-veracruz",
  tiktok: "https://tiktok.com/@multidentver",
  address: "Av. Víctor Sánchez Tapia #239, entre Isla Guadalupe y Costa de Marfil, Col. Astilleros, Veracruz, Veracruz",
  map_embed:
    "https://maps.google.com/maps?q=19.208605,-96.181465&hl=es&z=17&output=embed",
};
